// extracted by mini-css-extract-plugin
export var modalContainer = "index-module--modalContainer--n5cS7";
export var modal = "index-module--modal--2eNNU";
export var animation_open = "index-module--animation_open--MoL0D";
export var open_modal = "index-module--open_modal---vmps";
export var animation_fadeIn = "index-module--animation_fadeIn--3Bbof";
export var fadeIn = "index-module--fadeIn--PDkuT";